export const capitalizeFirstLetter = (word: string, type = 1) => {
  if (!word) return;
  if (type === 1) {
    return (
      word.substring(0, 1).toLocaleUpperCase() +
      word.substring(1).toLocaleLowerCase()
    );
  } else {
    let words = word.split(" ");
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }
    return words.join(" ");
  }
};
